import React from 'react';
import { ClipboardXIcon, HelpCircleIcon, LayersIcon, RefreshCwIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  question: HelpCircleIcon,
  clipboard: ClipboardXIcon,
  refresh: RefreshCwIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-brand-night" data-id="element-137" data-mp="2vp69s4k70652">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-138" data-mp="39gb54ugj2c9l">
        <p className="inline-block rounded bg-brand-red px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-139" data-mp="35h2alndnyacz">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-base font-extrabold leading-tight sm:text-xl" data-id="element-140" data-mp="3egh30sde4v04">
          Quieres enseñar Arduino y Robótica de forma práctica, pero preparar
          cada clase te lleva{' '}
          <span className="bg-brand-yellow px-1" data-id="element-141" data-mp="1k4shu8gkfw7a">demasiado tiempo.</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-night/75" data-id="element-142" data-mp="jeohqcic5sor">
          Si eres profesor técnico o quieres organizar mejor tus clases,
          probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-143" data-mp="x4i6yvxr6ez0">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-brand-red bg-[#FFF1EF] p-2.5 text-left" data-id="element-144" data-mp="123d1gv531ryy" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-red" data-id="element-145" data-mp="1g3w4fnuoy7u9">
                  <Icon size={15} className="text-white" data-id="element-146" data-mp="3du77rpf9rrl6" />
                </span>
                <div data-id="element-147" data-mp="3hu7lt8ygi0rp">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-148" data-mp="3hvsib44bzts7">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-brand-night/75" data-id="element-149" data-mp="k15xsc2g3c97">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}